<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="140px">
            <el-row :gutter="50">
                <el-col :span="12">
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="form.title" placeholder="请输入标题，不超过50个字符" maxlength="50"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="标题（英文）" prop="enTitle">
                        <el-input v-model="form.enTitle" placeholder="请输入标题（英文），不超过50个字符" maxlength="50"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="问题答复" prop="answer">
                        <Editor v-model="form.answer" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="问题答复（英文）" prop="enAnswer">
                        <Editor v-model="form.enAnswer" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="权重" prop="weight">
                <el-input v-model="form.weight" placeholder="请输入权重" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Editor from "@/components/Editor.vue";
import { add, edit, detail } from "@/api/content/question";
export default {
    components: { Editor },
    data() {
        return {
            form: {
                title: "",
                answer: "",
                enTitle: "",
                enAnswer: "",
                weight: ""
            },
            rules: {
                title: [{ required: true, message: "请输入标题", trigger: "blur" }],
                answer: [{ required: true, message: "请输入问题答复", trigger: "blur" }],
                enTitle: [{ required: true, message: "请输入标题（英文）", trigger: "blur" }],
                enAnswer: [{ required: true, message: "请输入问题答复（英文）", trigger: "blur" }],
                weight: [{ required: true, message: "请输入权重", trigger: "blur" }],
            }
        }
    },
    mounted() {
        const id = this.$route.query.id;
        if (id) {
            detail({ id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.form = result;
                } else {
                    this.$message.error(message);
                }
            });
        }
    },
    methods: {
        handleCancel() {
            this.$router.back();
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.form.id) {
                    edit(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                } else {
                    add(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                }
            });
        }
    }
}
</script>

<style></style>